import { getParcels, toApiError } from "@/shared/providers/api";
import type { Paginated, Parcel } from "@/shared/types";
import { call, put, takeLatest } from "redux-saga/effects";
import { FEATURED_COUNT, landingActions } from "./slice";

function* fetchFeatured() {
  try {
    const data: Paginated<Parcel> = yield call(getParcels, {
      status: "available",
      pageSize: FEATURED_COUNT,
      page: 1,
    });
    yield put(landingActions.fetchFeaturedSuccess(data.content));
  } catch (error) {
    yield put(landingActions.fetchFeaturedFailure(toApiError(error)));
  }
}

export function* landingSaga() {
  yield takeLatest(landingActions.fetchFeatured.type, fetchFeatured);
}
